<template>
  <div class="optionArea">
    <template v-if="type == 'radio'">

      <radio-matck-making :language="language" :call-change-in-option="callChangeInOption"
                          :items="options.question.question_options" @answerHandler="answerHandler($event)"/>
    </template>
    <template v-else-if="type == 'checkbox'">


      <checkbox-match-making :language="language" :call-change-in-option="callChangeInOption"
                             :items="options.question.question_options" @answerHandler="answerHandler($event)"/>
    </template>
    <template v-else-if="type == 'text'">
      <text-box-match-making :language="language" :call-change-in-option="callChangeInOption"
                             :items="options.question.question_options" @answerHandler="answerHandler($event)"/>
    </template>
    <template v-else-if="type == 'trueFalse'">

      <BoolHandlerMatchMacking :language="language" :call-change-in-option="callChangeInOption"
                               :items="options.question.question_options" @answerHandler="answerHandler($event)"/>
    </template>
    <template v-else-if="type == 'numericRange'">
      <NumricRangeMatchMacking :language="language" :call-change-in-option="callChangeInOption"
                               :items="options.question.question_options" @answerHandler="answerHandler($event)"/>
    </template>
    <template v-else-if="type == 'selectBox'">

      <SelectedBoxMatchMacking :language="language" :call-change-in-option="callChangeInOption"
                               :items="options.question.question_options" @answerHandler="answerHandler($event)"/>
    </template>
  </div>
</template>

<script>

import RadioMatckMaking from "@/components/MatchMaking/options/radioMatckMaking";
import CheckboxMatchMaking from "@/components/MatchMaking/options/checkboxMatchMaking";
import TextBoxMatchMaking from "@/components/MatchMaking/options/textBoxMatchMaking";
import BoolHandlerMatchMacking from "@/components/MatchMaking/options/BoolHandlerMatchMacking";
import NumricRangeMatchMacking from "@/components/MatchMaking/options/numricRangeMatchMacking";
import SelectedBoxMatchMacking from "@/components/MatchMaking/options/selectedBoxMatchMacking";

export default {
  name: "optionHandlerMatchMaking",
  components: {
    SelectedBoxMatchMacking,
    NumricRangeMatchMacking,
    BoolHandlerMatchMacking, TextBoxMatchMaking, CheckboxMatchMaking, RadioMatckMaking
  },
  props: {
    options: Object,
    type: String,
    callChangeInOption: Boolean,
  },
  computed: {
    language() {
      if (this.$store.getters.getLocal === null || this.$store.getters.getLocal === undefined)
        return 'fa';

      return this.$store.getters.getLocal;
    },
  },
  data() {
    return {
      data: {},
    }
  },
  methods: {
    answerHandler(val) {
      this.data = {
        "test_id": 1,
        "user_m_test_id": this.options.user_m_test_id,
        "question_stack_id": this.options.id,
        "answers": [
          ...val
        ]
      }
    },
  },
  watch: {
    data() {
      this.$emit('prepareData', this.data)
    },

  }
}
</script>

<style>
@media (min-width: 200px ) and (max-width: 800px) {
  .confirmBtn {

  }

  .optionArea {
    margin-bottom: 100px !important;
  }
}


.confirmBtn {
  width: 268px;
  height: 50px !important;
  border-radius: 10px !important;
  margin: 20px auto;
  color: white !important;
  font-size: 17px !important;
  font-weight: 500 !important;
}


</style>